import {
  type STImageMarker,
  STImageMarkerType,
  type STMapMarker,
  STMapMarkerType,
  type SandTableGroupSettings,
  type SandTableImageGroupItem,
  type SandTableMapGroupItem,
} from '@types';
import { createApi, createDomain } from 'effector';
import { createGate } from 'effector-react';
import produce, { type Draft } from 'immer';

const domain = createDomain('editingMapMarker');

interface MMStore {
  marker: STMapMarker;
  isNew?: boolean;
  batchMode?: boolean; // 是否批量模式
}

export const $editingMapMarker = domain.store<MMStore | null>(null);
export const $editingMapMarkerApi = createApi($editingMapMarker, {
  set: (state, payload: MMStore) => payload,
  clear: () => null,
  update: (
    state,
    updater: (draft: Draft<STMapMarker>) => STMapMarker | void
  ) => {
    if (!state) return state;
    return { ...state, marker: produce(state.marker, updater) };
  },
  move: (
    state,
    payload: {
      id: string;
      lng: number;
      lat: number;
    }
  ) => {
    if (state?.marker.id !== payload.id) return state;
    return produce(state, (draft) => {
      switch (draft.marker.type) {
        case undefined:
        case STMapMarkerType.scene:
        case STMapMarkerType.point:
        case STMapMarkerType.text:
        case STMapMarkerType.image: {
          draft.marker.icon.lat = payload.lat;
          draft.marker.icon.lng = payload.lng;
          break;
        }
        default:
          return state;
      }
    });
  },
});

/** 标记编辑是否是`选中状态` */
export const $GateMapMarkerActive = createGate({ domain, defaultState: false });

/** 编辑中显示的提示信息 */
export const $GateMapMarkerTip = createGate<string[]>({
  domain,
  defaultState: [],
});

export const MapCaptureGate = createGate({ domain, defaultState: false });

interface IMStore {
  marker: STImageMarker;
  isNew?: boolean;
  isActive?: boolean; // 是否显示选中状态图标
  zOrder?: number;
  batchMode?: boolean; // 是否批量模式
}

export const $editingImageMarker = domain.store<IMStore | null>(null);
export const $editingImageMarkerApi = createApi($editingImageMarker, {
  set: (state, payload: IMStore) => payload,
  clear: () => null,
  setIsActive: (state, payload: boolean) => {
    if (!state) return;
    return { ...state, isActive: payload };
  },
  update: (
    state,
    updater: (draft: Draft<STImageMarker>) => STImageMarker | void
  ) => {
    if (!state) return state;
    return {
      ...state,
      marker: produce(state.marker, (draft) => {
        draft.type ??= STImageMarkerType.scene;
        updater(draft);
      }),
    };
  },
});

// 批量/分组/高级设置 编辑中
export const $GateSandtableGroup = createGate<{
  data: Pick<
    SandTableMapGroupItem | SandTableImageGroupItem,
    'id' | 'name' | 'icon'
  >;
  index: number;
} | null>({ defaultState: null, domain });

export const $GateSandtableGroupSettings =
  createGate<SandTableGroupSettings | null>({
    defaultState: null,
    domain,
  });
